import { render, staticRenderFns } from "./Index_backups.vue?vue&type=template&id=3f31d2b2&scoped=true"
import script from "./Index_backups.vue?vue&type=script&lang=js"
export * from "./Index_backups.vue?vue&type=script&lang=js"
import style0 from "./Index_backups.vue?vue&type=style&index=0&id=3f31d2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f31d2b2",
  null
  
)

export default component.exports